module.exports = __webpack_public_path__ + "static/img/img_6.7d15ddfa.jpg";